import { createRouter } from '@tanstack/react-router'

import { DefaultErrorPage } from '#components/default-error-page'
import { DefaultLoader } from '#components/default-loader'
import { DefaultNotFoundPage } from '#components/default-not-found-page'
import { getQueryClient } from '#lib/react-query'

import { routeTree } from './routeTree.gen'

// Set up a Router instance
export const router = createRouter({
  routeTree,
  context: {
    queryClient: getQueryClient(),
    trpc: undefined!,
  },
  defaultErrorComponent: DefaultErrorPage,
  defaultNotFoundComponent: DefaultNotFoundPage,
  defaultPendingComponent: DefaultLoader,
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
})

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
